import { SignUpForm } from "@/components";
import { Helmet } from "react-helmet-async";
import PageTitle from "@/components/ui/page-title";

const SignUpPage = () => {
  return (
    <>
      <Helmet>
        <title>Criar Conta - MoovaTV</title>
        <meta name="description" content="Crie sua conta MoovaTV." />
      </Helmet>

      <div className="flex flex-col items-center justify-center min-h-screen">
        <PageTitle className="mb-8">Criar Conta no</PageTitle>
        <SignUpForm />
      </div>
    </>
  );
};

export default SignUpPage;
